import React from 'react'
import Text from '../ui/Text'
import Link from '../ui/Link'

const resourceHref = ({ collectId, draftId, resourceId, spontaneous }) => {
  if (spontaneous)
    return `/collects/${collectId}/resources/${resourceId}/answers`
  if (draftId)
    return `/collects/${collectId}/drafts/${draftId}/resources/${resourceId}/sections`
  return null
}

const ResourceCell = ({ collectId, draftId, resourceId, name, spontaneous }) => {
  const href = resourceId ? resourceHref({ collectId, draftId, resourceId, spontaneous }) : null
  if (!href)
    return <Text lines={2}>{name || '-'}</Text>
  return <Link href={href} lines={2} target="_blank">{name}</Link>
}

export default ResourceCell
